import db from './firebase'

export function pushIdea(idea) {
  if (idea !== "") {
    db.ref('all-ideas').push(idea);
    db.ref("ideas").push(idea);
  }
}